/****************************************************
 * Module Name:  queryStringGenerator.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
const mapToURLParameters = (obj) => {
  let params = Object.keys(obj)
    .filter((key) => obj[key] !== undefined && obj[key] !== null)
    .map((key, index) => `${key}=${encodeURIComponent(obj[key].toString())}`);
  return "?" + params.join("&");
};

const createURLQuery = (obj, endpointURL) => {
  let paramString = mapToURLParameters(obj);
  return endpointURL + paramString;
};

export default createURLQuery;
